import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import axios from 'axios';
import './fill-priority-form.less';
import SelectField from '../../../shared/form-elements/select/field';

const Form = props => {

	return (
		<form
			className='fill-priority-form display-flex-column'
			onSubmit={props.handleSubmit(async data => {
				await axios.post('v2/offers/priority', {
					offer_id: props.row.id,
					priority: data.priority && data.priority[0] && data.priority[0].value
				});
				await props.fetchData();
			})}
		>
			<div>
				<Field
					name='priority'
					multi={false}
					searchable={false}
					component={SelectField}
					options={props.offerPriorities.map((c) => ({ value: c.id, label: c.text }))}
					placeholder={'Priority'}
				/>
			</div>
			<div className="flex-center">
				<button className="ui-btn ui-btn-primary">
					Set priority
				</button>
			</div>
		</form>
	);
};

Form.propTypes = {
	intl: PropTypes.func
};

export default reduxForm({ form: 'fillPriorityForm' })(
	connect(state => ({ offerPriorities: state.root.lists['offer-priorities'] }))(Form)
);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/components/table-additional/fill-priority-form.js